import { render, staticRenderFns } from "./AiMonthReportPromptTemplateList.vue?vue&type=template&id=da861be6&"
import script from "./AiMonthReportPromptTemplateList.vue?vue&type=script&lang=ts&"
export * from "./AiMonthReportPromptTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./AiMonthReportPromptTemplateList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VRow,VSpacer})
